import { render } from "./AddOrEditGroupModal.vue?vue&type=template&id=77179ab0"
import script from "./AddOrEditGroupModal.vue?vue&type=script&lang=js"
export * from "./AddOrEditGroupModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\mestre\\mestre-do-valor-sn-administrativo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__